class RoSizeGuide extends RoSidebarBase {
  constructor() {
    super();
  }

  /*
   * Lifecycle method called when the component is connected to the DOM
   */
  connectedCallback() {
    super.connectedCallback(); // Call setup from RoSidebarBase
    this.content = this.el.children[1]; // Select content as the second child
    this.sizeGuideCloseButton = this.querySelector('.js-size-guide-close');

    subscribe(PUB_SUB_EVENTS.sizeGuideRequested, () => {
      this.open();
    });

    this.bindEvents();
  }

  /*
   * Override the open method to close the dialog first
   */
  open() {
    this.ensureDefaultUomSelected();
    publish(PUB_SUB_EVENTS.sizeGuideOpen);
    super.open();
  }

  /**
   * Ensures cm is selected when opening (each embedded guide uses its own radio `name`).
   * @returns {void}
   */
  ensureDefaultUomSelected() {
    const cmRadio = this.querySelector('input[type="radio"][value="cm"]');
    const inRadio = this.querySelector('input[type="radio"][value="in"]');
    if (!cmRadio) return;
    if (!inRadio?.checked) {
      cmRadio.checked = true;
    }
  }

  close() {
    super.hide();
    publish(PUB_SUB_EVENTS.sizeGuideClosed);
  }

  /*
   * Bind events, specifically the button click for opening the size guide menu
   */
  bindEvents() {
    super.bindEvents();

    // Attach event listeners to size guide close button
    if (this.sizeGuideCloseButton) {
      this.sizeGuideCloseButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.close();
      });
    }
  }

  /*
   * Override the animation method to modify the animation open state and hidden state
   * @param {boolean} opening - The direction of the animation
   */
  animateContent(opening) {
    const openState = 'translateY(0)';
    const hiddenState = 'translateY(100%)';
    const startTranslate = opening ? hiddenState : openState;
    const endTranslate = opening ? openState : hiddenState;

    const animationTime = 300;
    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.content.animate({
      transform: [startTranslate, endTranslate],
      opacity: [opening ? 0 : 1, opening ? 1 : 0]
    }, {
      duration: animationTime,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(opening);
    this.animation.oncancel = () => (this.isClosing = this.isExpanding = false);
  }
}

if (!customElements.get('ro-size-guide')) {
  customElements.define('ro-size-guide', RoSizeGuide);
}
